import React, { PureComponent, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import parse from 'html-react-parser';

class NaverBlogItem extends PureComponent {
  _goBlog = () => {
    const { bloggerlink } = this.props.childProps;
    window.open(bloggerlink, '', '');
  };
  _goPost = () => {
    const { link } = this.props.childProps;
    window.open(link, '', '');
  };
  render() {
    const { bloggername, description, postdate, title } = this.props.childProps;
    const { imgUrl } = this.props;

    const yyyy = postdate.substr(0, 4);
    const mm = postdate.substr(4, 2);
    const dd = postdate.substr(6, 2);

    const wdate = yyyy + '.' + mm + '.' + dd;
    return (
      <Fragment>
        <div className="store_card bl_bl">
          {/* 카드 상단/ */}
          <div className="store_card_top">
            <span className="tag">
              핫 블로그
              <i>
                <img src={imgUrl + '/img/store/sns_naver.png'} alt="네이버" />
              </i>
            </span>
          </div>
          {/* 카드 타이틀/ */}
          <div className="store_card_tit">
            <p className="date">
              <span
                className="writer"
                onClick={this._goBlog}
                style={{ cursor: 'pointer' }}
              >
                {bloggername}
              </span>
              <span>{wdate}</span>
            </p>
            <p className="tit" onClick={this._goPost}>
              {parse(title)}
            </p>
          </div>
          {/* 카드 컨텐츠 내용 */}
          <div className="store_card_txt" onClick={this._goPost}>
            {parse(description)}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(NaverBlogItem)));
